import { useEffect } from 'react'
import { ObjectWithRecordsType } from 'src/types'

import { useFetchObjectDataWithFixedKey } from '@components/DisplayForm/hooks/useFetchObjectDataWithFixedKey'

type UseFetchRowByUpdateProps = {
  objectsWithDirtyRecords: ObjectWithRecordsType
  objectCode: string
  formCode: string
  objectId?: string
  globalId: string
  // fetchRow: MutationType<GETObjectDataRecordParams, ObjectDataRecord>
}

export const useFetchRowByUpdate = ({
  objectsWithDirtyRecords,
  objectCode,
  formCode,
  objectId,
  globalId,
}: UseFetchRowByUpdateProps) => {
  const [fetchRow] = useFetchObjectDataWithFixedKey(globalId)

  useEffect(() => {
    const object = objectsWithDirtyRecords[objectCode]

    if (object && Object.keys(object).length) {
      if (formCode && objectId) {
        fetchRow({ formCode, objectId })
      }

      return
    }
  }, [objectsWithDirtyRecords, formCode, objectId])
}
